import { ActivityStatus } from "@cca/components";
import { ActivityDto, LcmsActivityDto } from "@core/typesV2";
import { useService } from "@providersV2";
import { ActivityProgressService } from "@servicesV2";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type StartActivityMutationParam = {
  activityId: string;
};

type ActivitiesQueryData = {
  activities: ActivityDto[];
  lcmsItems: LcmsActivityDto[];
};

export function useStartActivity(courseId: string, dayId: string) {
  const queryClient = useQueryClient();
  const { initialization: activityProgressServiceInit } = useService(
    ActivityProgressService,
  );

  return useMutation({
    mutationFn: async ({ activityId }: StartActivityMutationParam) => {
      const { service: activityProgressService } =
        await activityProgressServiceInit;

      await activityProgressService.startActivity(courseId, activityId);
    },

    onSuccess: (_, { activityId }) => {
      const queryKey = ["courses", courseId, "dayId", dayId, "learnerId", null];

      queryClient.setQueryData<ActivitiesQueryData>(queryKey, (data) => {
        if (!data) return data;

        return {
          ...data,
          activities: data.activities.map((activity) =>
            activity.activityId === activityId && activity.progress
              ? {
                  ...activity,
                  progress: {
                    ...activity.progress,
                    status: ActivityStatus.InProgress,
                  },
                }
              : activity,
          ),
        };
      });

      queryClient.invalidateQueries({
        queryKey,
        refetchType: "none",
      });
    },
  });
}
